import React, { useState, useEffect } from "react";
import Loader from "../component/Loader";
import Select from "react-select";
import Swal from "sweetalert2";
import { getData, postData } from "../store/utils";
import { FaUpload } from 'react-icons/fa';
import { useParams, useHistory } from "react-router-dom";
import { Trash2, Eye, EyeOff, } from 'lucide-react';


function UpdateVendor() {
    const { id } = useParams();
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const [salutationData, setSalutationData] = useState('');
    const [udyamRegistrationNumber, setUdyamRegistrationNumber] = useState('');
    const [udyamData, setUdyamData] = useState('');
    const [currency, setCurrency] = useState(null);
    const [paymentTerm, setPaymentTerm] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [workPhone, setWorkPhone] = useState('');
    const [mobile, setMobile] = useState(''); 
    const [panNumber, setPanNumber] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [uinNumber, setUinNumber] = useState('');
    const [websiteUrl, setWebsiteUrl] = useState('');
    const [designation, setDesignation] = useState('');
    const [department, setDepartment] = useState('');
    const [facebookLink, setFacebookLink] = useState('');
    const [skypeLink, setSkypeLink] = useState('');
    const [tweeterLink, setTweeterLink] = useState('');
    const [tds, setTds] = useState(null);
    const [enablePortal, setEnablePortal] = useState(false);
    const [portalLanguage, setPortalLanguage] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [isMsmeRegistered, setIsMsmeRegistered] = useState(''); 
    const [isPortalAccessEnabled, setIsPortalAccessEnabled] = useState('');
    const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
    const [activeTab, setActiveTab] = useState('otherDetails');
    const [billingAddress, setBillingAddress] = useState({});
    const [shippingAddress, setShippingAddress] = useState({});
    const [bankDetails, setBankDetails] = useState([]);
    const [remarks, setRemarks] = useState('');
    const [showTopMessage, setShowTopMessage] = useState(false);
    const [errors, setErrors] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [showAccountNumbers, setShowAccountNumbers] = useState({});
    const history = useHistory();
    const userInfo = JSON.parse(localStorage.getItem("USER_DATA"));
    const employeeId = userInfo.employeeId;
    const [formData, setFormData] = useState({
        salutation: "",
        firstName: "",
        lastName: "",
        companyName: "",
        displayName: "",
        email: "",
        phoneNumber: "",
        mobileNumber: "",
        panNumber: "",
        gstNumber: "",
        uinNumber: "",
        isMsmeRegistered: "No",
        udyamRegistrationType: "",
        udyamRegistrationNumber: "",
        department: "",
        designation: "",
        currency: "",
        paymentTerms: "",
        tds: 0,
        isPortalAccessEnabled: "No",
        language: "",
        billingCountry: 'India',
        billingAddessLine1: '',
        billingAddessLine2: '',
        billingCity: '',
        billingState: '',
        billingPincode: '',
        billingPhoneNumber: '',
        billingFaxNumber: '',
        shippingCountry: 'India',
        shippingAddessLine1: '',
        shippingAddessLine2: '',
        shippingCity: '',
        shippingState: '',
        shippingPincode: '',
        shippingPhoneNumber: '',
        shippingFaxNumber: '',
        documentPath: [],
        websiteUrl: "",
        tweeterLink: "",
        facebookLink: "",
        skypeLink: "",
        remarks: "",
        createdBy: employeeId,
        updatedBy: employeeId,
        contactPersons: [
          {
            salutation: "",
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            mobileNumber: "",
            skypeLink: "",
            designation: "",
            department: ""
          }
        ],
        bankDetails: [
          {
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            confirmAccountNumber: "",
            ifscCode: ""
          }
        ]
    });     
    
    const copyBillingToShipping = () => {
        const mappedShipping = {
            shippingCountry: formData.billingCountry || '',
            shippingAddessLine1: formData.billingAddessLine1 || '',
            shippingAddessLine2: formData.billingAddessLine2 || '',
            shippingCity: formData.billingCity || '',
            shippingState: formData.billingState || '',
            shippingPincode: formData.billingPincode || '',
            shippingPhoneNumber: formData.billingPhoneNumber || '',
            shippingFaxNumber: formData.billingFaxNumber || '',
        };
        setShippingAddress(mappedShipping);
        setFormData((prev) => ({ ...prev, ...mappedShipping }));
    };

    const toggleAccountNumberVisibility = (index) => {
        setShowAccountNumbers((prev) => ({
          ...prev,
          [index]: !prev[index],
        }));
    };

    useEffect(() => {
        Object.entries(billingAddress).forEach(([key, value]) => {
            if (key.startsWith("billing")) {
                setFormData(prev => ({
                    ...prev,
                    [key]: value || prev[key] || ""
                }));
            }
        });
    }, [billingAddress]);
    
    useEffect(() => {
        Object.entries(shippingAddress).forEach(([key, value]) => {
            if (key.startsWith("shipping")) {
                setFormData(prev => ({
                    ...prev,
                    [key]: value || prev[key] || ""
                }));
            }
        });
    }, [shippingAddress]);    

    const handleContactChange = (index, field, value) => {
        const updatedContacts = [...formData.contactPersons];
        updatedContacts[index][field] = value;
    
        setFormData((prevData) => ({
            ...prevData,
            contactPersons: updatedContacts
        }));
    };

    const addContactPerson = () => {
        setFormData((prevData) => ({
            ...prevData,
            contactPersons: [
                ...prevData.contactPersons,
                {
                    salutation: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    mobileNumber: '',
                    skypeLink: '',
                    designation: '',
                    department: ''
                }
            ]
        }));
    };

    const removeContactPerson = (index) => {
        setFormData(prev => {
            const contactToDelete = prev.contactPersons[index];
            const updated = prev.contactPersons.filter((_, i) => i !== index);
    
            if (contactToDelete.id) {
                updated.push({ ...contactToDelete, deleteContactId: -1 });
            }
    
            return {
                ...prev,
                contactPersons: updated
            };
        });
    };

    const addBankDetail = () => {
        setFormData(prev => ({
            ...prev,
            bankDetails: [
                ...prev.bankDetails,
                {
                    accountHolderName: '',
                    bankName: '',
                    accountNumber: '',
                    confirmAccountNumber: '',
                    ifscCode: '',
                    isNew: true
                }
            ]
        }));
    };
    
    const removeBankDetail = (index) => {
        setFormData(prev => {
            const bankToDelete = prev.bankDetails[index];
            const updated = prev.bankDetails.filter((_, i) => i !== index);
    
            if (bankToDelete.id) {
                updated.push({ ...bankToDelete, deleteBankId: -1 });
            }
    
            return {
                ...prev,
                bankDetails: updated
            };
        });
    };
    
    const handleBankChange = (index, field, value) => {
        const updated = [...formData.bankDetails];
        updated[index][field] = value;
        setFormData(prev => ({
            ...prev,
            bankDetails: updated
        }));
    };    

    const salutationOptions = [
        { value: 'mr', label: 'Mr.' },
        { value: 'mrs', label: 'Mrs.' },
        { value: 'ms', label: 'Ms.' },    
        { value: 'miss', label: 'Miss' }, 
        { value: 'dr', label: 'Dr.' },
    ];

    const udyamOptions = [
        { value: 'micro', label: 'Micro' },
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },    
    ];

    const CurrencyOptions = [
        { value: 'AED', label: 'AED-UAE Dhirham' },
        { value: 'AUD', label: 'AUD-Australian Dollar' },
        { value: 'BND', label: 'BND-Brunei Dollar' },
        { value: 'CAD', label: 'CAD-Canadian Dollar' },
        { value: 'CNY', label: 'CNY-Yuan Renminbi' },
        { value: 'EUR', label: 'EUR-Euro' },
        { value: 'GBP', label: 'GBP-Pound Sterling' },    
        { value: 'INR', label: 'INR-Indian Rupee' }, 
        { value: 'JPY', label: 'JPY-Japanese Yen' }, 
        { value: 'SAR', label: 'SAR-Soudi Riyal' },    
        { value: 'USD', label: 'USD-United States Dollar' }, 
        { value: 'ZAR', label: 'ZAR-South Afreican Rand' },
    ];
    
    const PaymentTermsOptions = [
        { value: 'net15', label: 'Net 15' },
        { value: 'net30', label: 'Net 30' },
        { value: 'net45', label: 'Net 45' }, 
        { value: 'net60', label: 'Net 60' },
        { value: 'dueOnReciept', label: 'Due On Reciept' },
        { value: 'dueOfMonth', label: 'Due Of Month' },
        { value: 'dueEndOfNextMonth', label: 'Due Of Next Month' },
    ];

    const tdsOptions = [
        { value: "commissionOrBrokerage", label: "Commission or Brokerage [2%]" },
        { value: "commissionOrBrokerageReduced", label: "Commission or Brokerage (Reduced)[3.75%]" },
        { value: "divident", label: "Divident [10%]" },
        { value: "dividentReduced", label: "Divident (Reduced) [7.5%]" },
        { value: "otherInterestThanSecurities", label: "Other interest than Securities [10%]" },
        { value: "otherInterestThanSecuritiesReduced", label: "Other interest than Securities (Reduced) [7.5%]" },
        { value: "paymentOfContractorsForOthers", label: "Payment of Contractors for Others [2%]" },
        { value: "paymentOfContractorsForOthersReduced", label: "Payment of Contractors for Others (Reduced) [1.5%]" },
        { value: "paymentOfContractorsForHUF/Idiv", label: "Payment of Contractors for HUF/Idiv [1%]" },
        { value: "paymentOfContractorsForHUF/IdivReduced", label: "Payment of Contractors for HUF/Idiv (Reduced) [0.75%]" },
        { value: "professionalFees", label: "Professional Fees [10%]" },
        { value: "professionalFeesReduced", label: "Professional Fees (Reduced) [7.5%]" },
        { value: "rentOnLandOrFurniture", label: "Rent on land or furniture etc [10%]" },
        { value: "rentOnLandOrFurnitureReduced", label: "Rent on land or furniture etc (Reduced) [7.5%]" },
        { value: "technicalFess", label: "Technical Fess [2%]" },
    ];
    
    const languageOptions = [
        { value: "english", label: "English" },
        { value: "spanish", label: "Spanish" },
        { value: "french", label: "French" },
        { value: "german", label: "German" },
        { value: "chinese", label: "Chinese" },
    ];

    const fieldLabels = {
        accountHolderName: "Account Holder Name",
        bankName: "Bank Name",
        accountNumber: "Account Number",
        confirmAccountNumber: 'Confirm Account Number',
        ifscCode: "IFSC Code"
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const validFiles = selectedFiles.filter(
          (file) => file.size <= 10 * 1024 * 1024
        );
    
        if (validFiles.length + documents.length > 10) {
          alert("You can upload a maximum of 10 files.");
          return;
        }
    
        setDocuments([...documents, ...validFiles]);
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.firstName.trim()) {
            errors.firstName = "First Name is required.";
        }
        if (!formData.lastName.trim()) {
            errors.lastName = "Last Name is required.";
        }
        if (!formData.companyName.trim()) {
            errors.companyName = "Company Name is required.";
        }
        if (!formData.displayName.trim()) {
            errors.displayName = "Display Name is required.";
        }
        if (!formData.mobileNumber.trim()) {
            errors.mobileNumber = "Mobile Number is required.";
        } else {
            const mobileRegex = /^[6-9]\d{9}$/;
            if (!mobileRegex.test(formData.mobileNumber)) {
                errors.mobileNumber = "Please enter a valid 10-digit mobile number.";
            }
        }
        if (formData.billingPhoneNumber) {
            const mobileRegex = /^[6-9]\d{9}$/;
            if (!mobileRegex.test(formData.billingPhoneNumber)) {
                errors.billingPhoneNumber = "Please enter a valid 10-digit billing phone number.";
            }
        }
        if (formData.shippingPhoneNumber) {
            const mobileRegex = /^[6-9]\d{9}$/;
            if (!mobileRegex.test(formData.shippingPhoneNumber)) {
                errors.shippingPhoneNumber = "Please enter a valid 10-digit shipping phone number.";
            }
        }
        if (isPortalAccessEnabled === "Yes") {
            if (!formData.email) {
                errors.email = "Email is required.";
            } else {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(formData.email)) {
                    errors.email = "Please enter a valid email address.";
                }
            }
        }
        if (formData.panNumber) {
            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
            if (!panRegex.test(formData.panNumber.toUpperCase())) {
                errors.panNumber = "Please enter a valid PAN number (e.g. ABCDE1234F).";
            }
        }
        if (formData.gstNumber) {
            const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
            if (!gstRegex.test(formData.gstNumber.toUpperCase())) {
                errors.gstNumber = "Please enter a valid GST number.";
            }
        }
        if (formData.uinNumber) {
            const uinRegex = /^[0-1][0-9]{1}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
            if (!uinRegex.test(formData.uinNumber.toUpperCase())) {
                errors.uinNumber = "Please enter a valid UIN number.";
            }
        }
        if (isPortalAccessEnabled === "Yes") {
            if (!formData.udyamRegistrationType) {
                errors.udyamRegistrationType = "Udyam Registration Type is required.";
            }
        
            if (!formData.udyamRegistrationNumber) {
                errors.udyamRegistrationNumber = "Udyam Registration Number is required.";
            } else {
                const udyamRegex = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;
                if (!udyamRegex.test(formData.udyamRegistrationNumber.toUpperCase())) {
                    errors.udyamRegistrationNumber = "Enter a valid Udyam number (e.g. UDYAM-MH-12-1234567).";
                }
            }
        }
        // Validate contact persons (only if at least one field is filled in)
        if (Array.isArray(formData.contactPersons)) {
            formData.contactPersons.forEach((person, index) => {
                if (person?.deleteContactId === -1) return;
                const relevantFields = ["firstName", "lastName", "mobileNumber", "email", "salutation", "phoneNumber", "skypeLink", "designation", "department"];
                const isFilled = relevantFields.some(field => person[field]?.toString().trim() !== '');
                if (isFilled) {
                    if (!person.firstName?.trim()) {
                        errors[`contactPersons.${index}.firstName`] = "First name is required.";
                    }
                    if (!person.lastName?.trim()) {
                        errors[`contactPersons.${index}.lastName`] = "Last name is required.";
                    }
                    if (!person.mobileNumber?.trim()) {
                        errors[`contactPersons.${index}.mobileNumber`] = "Mobile number is required.";
                    } else {
                        const mobileRegex = /^[6-9]\d{9}$/;
                        if (!mobileRegex.test(person.mobileNumber)) {
                            errors[`contactPersons.${index}.mobileNumber`] = "Invalid mobile number.";
                        }
                    }
                    if (person.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(person.email)) {
                        errors[`contactPersons.${index}.email`] = "Enter a valid email.";
                    }
                }
            });
        }

        // Validate bank details (only if at least one field is filled in)
        if (Array.isArray(formData.bankDetails)) {
            formData.bankDetails.forEach((bank, index) => {
                if (bank?.deleteBankId === -1) return;
                const isFilled = Object.values(bank || {}).some(val => val && val.toString().trim() !== '');
                if (isFilled) {
                    const requiredFields = ["accountHolderName", "bankName", "accountNumber", "ifscCode"];
                    requiredFields.forEach((field) => {
                        if (!bank[field]?.trim()) {
                            errors[`bankDetails.${index}.${field}`] = `${fieldLabels[field] || field} is required.`;
                        }
                    });

                    if (bank.accountNumber && bank.confirmAccountNumber && bank.accountNumber !== bank.confirmAccountNumber) {
                        errors[`bankDetails.${index}.confirmAccountNumber`] = "Account numbers do not match.";
                    }
                    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                    if (bank.ifscCode && !ifscRegex.test(bank.ifscCode.toUpperCase())) {
                        errors[`bankDetails.${index}.ifscCode`] = "Please enter a valid IFSC code.";
                    }
                }
            });
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    useEffect(() => {
        fetchVendorDetails(id);
    }, [id]);
    
    async function fetchVendorDetails(vendorId) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getVendorDetailsById?vendorId=${vendorId}`);
        setIsLoadingOn(false);
        
        if (tempData?.statusCode === 200) {
            const records = tempData?.data;
            // console.log(" records == ", records[0]);
            setSelectedVendor(records[0])
            setFormData(records[0]);
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoadingOn(true);
    
        const isValid = validateForm(); // Only call once
    
        if (!isValid) {
            setIsLoadingOn(false);
            return;
        }
        formData.vendorId = formData.id;
        const payload = { ...formData };
        try {
            const res = await postData(`inventory/updateVendor`, payload);
            setIsLoadingOn(false);
    
            if (res.statusCode === 200) {
                setShowTopMessage(true);
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Data Updated successfully!",
                    timer: 3000,
                    showConfirmButton: false,
                });
    
                setTimeout(() => {
                    setShowTopMessage(false);
                    history.push(`/vendorDetails/${id}`);
                }, 1000);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: res.data.errors.msg || "Something went wrong!",
                });
            }
        } catch (err) {
            setIsLoadingOn(false);
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Something went wrong during submission.",
            });
        }
    };    

    const handlePinCodeChange = async (value, type) => {
        if (value.length === 6) {
            setIsLoadingOn(true);
            let res = await getData(`users/getCityStateByPincode/${value}`);
            setIsLoadingOn(false);
            if (res.statusCode === 200 && Array.isArray(res.data) && res.data.length > 0) {
                const { district, stateName } = res.data[0];
                const updatedFields = {
                    [`${type}City`]: district,
                    [`${type}State`]: stateName,
                    [`${type}Country`]: 'India',
                };
                if (type === 'billing') {
                    setBillingAddress(prev => ({ ...prev, ...updatedFields }));
                } else {
                    setShippingAddress(prev => ({ ...prev, ...updatedFields }));
                }
                setFormData(prevData => ({
                    ...prevData,
                    ...updatedFields,
                }));
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: "Invalid Pin Code",
                });
            }
        }
    };    
    
    console.log("Form Data:", formData);
    return (
        <div className="">
            {isLoadingOn && <Loader />}
            <div className="sticky-header">
                <h1 className="form-title" style={{marginBottom: "20px"}}>Edit Vendor</h1>
            </div>

            <form className="vendor-form" onSubmit={handleSubmit}>
                <div className="vendor-form-wrapper"> 
                    <div className="form-layout">
                        <div className="form-row">
                            <label className="prchaseform-label">Primary Contact</label>
                            <div className="form-inputs inline-fields">
                                <div>
                                    <Select
                                        options={salutationOptions}
                                        placeholder="Salutation"
                                        value={salutationOptions.find(opt => opt.value === formData.salutation)}
                                        onChange={(selectedOption) => {
                                            setSalutationData(selectedOption?.value);
                                            setFormData({ ...formData, salutation: selectedOption?.value });
                                        }}
                                        isClearable
                                    />
                                    {formErrors.salutation && (
                                        <small className="error-text">{formErrors.salutation}</small>
                                    )}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        value={formData.firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value);
                                            setFormData({ ...formData, firstName: e.target.value });
                                        }}
                                    />
                                    {formErrors.firstName && (
                                        <small className="error-text">{formErrors.firstName}</small>
                                    )}
                                </div>
                                <div style={{ flex: 1, marginRight: "10px" }}>
                                    <input
                                        type="text"
                                        placeholder="Last Name"
                                        value={formData.lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value);
                                            setFormData({ ...formData, lastName: e.target.value });
                                        }}
                                    />
                                    {formErrors.lastName && (
                                        <small className="error-text">{formErrors.lastName}</small>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <label className="prchaseform-label">Company Name</label>
                            <div className="form-inputs">
                                <input
                                    type="text"
                                    value={formData.companyName}
                                    onChange={(e) => {
                                        setCompanyName(e.target.value);
                                        setFormData({ ...formData, companyName: e.target.value });
                                    }}
                                />
                                {formErrors.companyName && (
                                    <small className="error-text">{formErrors.companyName}</small>
                                )}
                            </div>
                        </div>

                        <div className="form-row">
                            <label className="prchaseform-label" style={{color: "red"}}>Display Name*</label>
                            <div className="form-inputs">
                                <input
                                    type="text"
                                    value={formData.displayName}
                                    onChange={(e) => {
                                        setDisplayName(e.target.value);
                                        setFormData({ ...formData, displayName: e.target.value });
                                    }}
                                />
                                {formErrors.displayName && (
                                    <small className="error-text">{formErrors.displayName}</small>
                                )}
                            </div>
                        </div>

                        <div className="form-row">
                            <label className="prchaseform-label">Email Address</label>
                            <div className="form-inputs">
                                <input
                                    type="email"
                                    value={formData.email}
                                    placeholder="Enter a valid email address"
                                    required={isPortalAccessEnabled === "Yes"}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        setEmail(input);
                                        setFormData({ ...formData, email: input });
                                    }}
                                    onBlur={() => {
                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                        if (isPortalAccessEnabled === "Yes" && !emailRegex.test(email)) {
                                            setFormErrors(prev => ({ ...prev, email: "Please enter a valid email address" }));
                                        } else {
                                            setFormErrors(prev => ({ ...prev, email: "" }));
                                        }
                                    }}
                                />
                                {formErrors.email && (
                                    <small className="error-text">{formErrors.email}</small>
                                )}
                            </div>
                        </div>

                        <div className="form-row">
                            <label className="prchaseform-label">Phone</label>
                            <div className="form-inputs inline-fields">
                                <div className="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Work Phone"
                                    value={formData.phoneNumber}
                                    onChange={(e) => {
                                        setWorkPhone(e.target.value);
                                        setFormData({ ...formData, phoneNumber: e.target.value });
                                    }}
                                />
                                {formErrors.phoneNumber && (
                                    <small className="error-text">{formErrors.phoneNumber}</small>
                                )}
                                </div>
                                <div className="input-wrapper">
                                <input
                                    type="tel"
                                    placeholder="Mobile"
                                    maxLength={10}
                                    value={formData.mobileNumber}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^[0-9]*$/.test(input)) {
                                            setMobile(input);
                                            setFormData({ ...formData, mobileNumber: input });
                                        }
                                    }}
                                    onBlur={() => {
                                        const mobileRegex = /^[6-9][0-9]{9}$/;
                                        if (mobile && !mobileRegex.test(mobile)) {
                                            setFormErrors(prev => ({ ...prev, mobileNumber: "Enter a valid 10-digit mobile number" }));
                                        } else {
                                            setFormErrors(prev => ({ ...prev, mobileNumber: "" }));
                                        }
                                    }}
                                />
                                {formErrors.mobileNumber && (
                                    <small className="error-text">{formErrors.mobileNumber}</small>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="vendor-form-wrapper" style={{width: "100%"}}> 
                    <div className="tabs">
                        <button type="button" className={activeTab === 'otherDetails' ? 'active' : ''} onClick={() => setActiveTab('otherDetails')}>Other Details</button>
                        <button type="button" className={activeTab === 'address' ? 'active' : ''} onClick={() => setActiveTab('address')}>Address</button>
                        <button type="button" className={activeTab === 'contact' ? 'active' : ''} onClick={() => setActiveTab('contact')}>Contact Persons</button>
                        <button type="button" className={activeTab === 'bank' ? 'active' : ''} onClick={() => setActiveTab('bank')}>Bank Details</button>
                        <button type="button" className={activeTab === 'custom' ? 'active' : ''} onClick={() => setActiveTab('custom')}>Custom Fields</button>
                        <button type="button" className={activeTab === 'reporting' ? 'active' : ''} onClick={() => setActiveTab('reporting')}>Reporting Tags</button>
                        <button type="button" className={activeTab === 'remarks' ? 'active' : ''} onClick={() => setActiveTab('remarks')}>Remarks</button>
                    </div>
                </div>
                <div className="form-layout">
                    {activeTab === 'otherDetails' && (
                        <div className="form-layout"> 
                            <div className="form-row">
                                <label className="prchaseform-label">PAN</label>
                                <div style={{ width: "300px" }}>
                                    <input
                                        type="panNumber"
                                        value={formData.panNumber}
                                        onChange={(e) => {
                                            const input = e.target.value.toUpperCase();
                                            const panRegex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/;
                                
                                            if (input === '' || panRegex.test(input)) {
                                                setPanNumber(input);
                                                setFormData({ ...formData, panNumber: input });
                                            }
                                        }}
                                    />
                                    {formErrors.panNumber && (
                                        <small className="error-text">{formErrors.panNumber}</small>
                                    )}
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">GST Number</label>
                                <div style={{ width: "300px" }}>
                                    <input
                                        type="gstNumber"
                                        value={formData.gstNumber}
                                        onChange={(e) => {
                                            const input = e.target.value.toUpperCase();
                                            const gstRegex = /^[0-9]{0,2}[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}[A-Z0-9]{0,3}$/;
                            
                                            if (input === '' || gstRegex.test(input)) {
                                                setGstNumber(input);
                                                setFormData({ ...formData, gstNumber: input });
                                            }
                                        }}
                                    />
                                    {formErrors.gstNumber && (
                                        <small className="error-text">{formErrors.gstNumber}</small>
                                    )}
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">UIN Number</label>
                                <div style={{ width: "300px" }}>
                                    <input
                                        type="uinNumber"
                                        value={formData.uinNumber}
                                        onChange={(e) => {
                                            const input = e.target.value.toUpperCase();
                                            const uinRegex = /^[0-9]{0,2}[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}[A-Z0-9]{0,3}$/;
                            
                                            if (input === '' || uinRegex.test(input)) {
                                                setUinNumber(input);
                                                setFormData({ ...formData, uinNumber: input });
                                            }
                                        }}
                                    />
                                    {formErrors.uinNumber && (
                                        <small className="error-text">{formErrors.uinNumber}</small>
                                    )}
                                </div>
                            </div>

                            <div className="form-row checkbox-group">
                                <label className="prchaseform-label">MSME Registered?</label>
                                <div style={{ width: "300px", display: "flex", alignItems: "center" }}>
                                    <input
                                    type="checkbox"
                                    id="msme"
                                    checked={formData.isMsmeRegistered === "Yes"}
                                    onChange={(e) => {
                                        setIsMsmeRegistered(e.target.checked ? "Yes" : "No");
                                        setFormData({ ...formData, isMsmeRegistered: e.target.checked ? "Yes" : "No" });
                                    }}
                                    style={{ marginRight: "8px" }}
                                    />
                                    <label htmlFor="msme" className="prchaseform-label" style={{minWidth: "300px", justifyItems: "center"}}>This vendor is MSME registered</label>
                                </div>
                            </div>
                            {formData.isMsmeRegistered === "Yes" && (
                                <>
                                <div className="form-row">
                                    <label className="prchaseform-label" style={{ color: "red" }}>MSME/Udyam Registration Type*</label>
                                    <div style={{ width: "300px" }}>
                                        <Select
                                            options={udyamOptions}
                                            placeholder="Select the Registration Type"
                                            value={udyamOptions.find(opt => opt.value === formData.udyamRegistrationType)}
                                            onChange={(selectedOption) => {
                                                setUdyamData(selectedOption?.value);
                                                setFormData({ ...formData, udyamRegistrationType: selectedOption?.value });
                                            }}
                                            isClearable
                                        />
                                        {formErrors.udyamRegistrationType && (
                                            <small className="error-text">{formErrors.udyamRegistrationType}</small>
                                        )}
                                    </div> 
                                </div>

                                <div className="form-row">
                                    <label className="prchaseform-label" style={{ color: "red" }}>MSME/Udyam Registration Number*</label>
                                    <div style={{ width: "300px" }}>
                                        <input
                                            type="udyamRegistrationNumber"
                                            value={formData.udyamRegistrationNumber}
                                            placeholder="Enter the Registration Number"
                                            onChange={(e) => {
                                                const input = e.target.value.toUpperCase();
                                                const allowedChars = /^[A-Z0-9-]*$/;
                                                if (input === '' || allowedChars.test(input)) {
                                                    setUdyamRegistrationNumber(input);
                                                    setFormData({ ...formData, udyamRegistrationNumber: input });
                                                }
                                            }}
                                        />
                                        {formErrors.udyamRegistrationNumber && (
                                            <small className="error-text">{formErrors.udyamRegistrationNumber}</small>
                                        )}
                                    </div>
                                </div>
                                </>
                            )}

                            <div className="form-row">
                                <label className="prchaseform-label">Currency</label>
                                <div className="form-inputs">
                                    <div style={{ width: "300px" }}>
                                        <Select
                                            options={CurrencyOptions}
                                            value={CurrencyOptions.find(opt => opt.value === formData.currency)}
                                            onChange={(selected) => {
                                                setCurrency(selected?.value);
                                                setFormData({ ...formData, currency: selected?.value });
                                            }}
                                            placeholder="Select Currency"
                                            isClearable
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">Payment Terms</label>
                                <div className="form-inputs">
                                    <div style={{ width: "300px" }}>
                                        <Select
                                            options={PaymentTermsOptions}
                                            value={PaymentTermsOptions.find(opt => opt.value === formData.paymentTerms)}
                                            onChange={(selected) => {
                                                setPaymentTerm(selected?.value);
                                                setFormData({ ...formData, paymentTerms: selected?.value });
                                            }}
                                            placeholder="Select Payment Term"
                                            isClearable
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">TDS</label>
                                <div style={{ width: "300px" }}>
                                    <Select
                                    options={tdsOptions}
                                    value={tdsOptions.find((opt) => opt.value === formData.tds)}
                                    onChange={(selected) => {
                                        setTds(selected?.value);
                                        setFormData({ ...formData, tds: selected?.value });
                                    }}
                                    placeholder="Select TDS"
                                    isClearable
                                    />
                                </div>
                            </div>

                            <div className="form-row checkbox-group">
                                <label className="prchaseform-label">Enable Portal?</label>
                                <div style={{ width: "300px", display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "10px" }}>
                                    <input
                                        type="checkbox"
                                        id="enablePortal"
                                        checked={formData.isPortalAccessEnabled === "Yes"}
                                        onChange={(e) => {
                                            setIsPortalAccessEnabled(e.target.checked ? "Yes" : "No");
                                            setFormData({ ...formData, isPortalAccessEnabled: e.target.checked ? "Yes" : "No" });
                                        }}
                                        style={{ marginRight: "4px" }}
                                    />
                                    <label htmlFor="enablePortal" className="prchaseform-label" style={{ minWidth: "300px" }}>Allow portal access for this vendor</label>
                                    {isPortalAccessEnabled === "Yes" && (
                                        <label className="prchaseform-label" style={{ minWidth: "300px", color: "red" }}>
                                            (Email address is mandatory)
                                        </label>
                                    )}                                
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">Portal Language</label>
                                <div style={{ width: "300px" }}>
                                <Select
                                    options={languageOptions}
                                    value={languageOptions.find((opt) => opt.value === formData.language)}
                                    onChange={(selected) => {
                                        setPortalLanguage(selected?.value);
                                        setFormData({ ...formData, language: selected?.value });
                                    }}
                                    placeholder="Select Language"
                                    isClearable
                                />
                                </div>
                            </div>

                            <div className="form-row">
                                <label className="prchaseform-label">Documents</label>
                                <div style={{ width: "300px", position: "relative" }}>
                                    <input
                                        id="fileUpload"
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        accept=".pdf,.doc,.docx,.jpg,.png"
                                        style={{ display: 'none' }}
                                    />

                                    <label
                                        htmlFor="fileUpload"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '1px dashed #aaa',
                                            borderRadius: '6px',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            backgroundColor: '#f9f9f9',
                                            width: '60%',
                                            gap: '8px'
                                        }}
                                    >
                                    <FaUpload style={{ color: '#1a73e8' }} />
                                    <span style={{ color: '#1a73e8', fontWeight: 500 }}>Upload Files</span>
                                    </label>

                                    <p className="prchaseform-label" style={{ width: "500px", color: "#888484", marginTop: '5px' }}>
                                    You can upload a maximum of 3 files, 5MB each
                                    </p>
                                </div>
                            </div>

                            <div className="form-row">
                            <button
                                type="button"
                                className="btn-link"
                                style={{border: "none", background: "transparent" }}
                                onClick={() => setShowAdditionalDetails(!showAdditionalDetails)}
                            >
                                Add More Details
                            </button>
                            </div>

                            {showAdditionalDetails && (
                                <>
                                    <div className="form-row">
                                        <label className="prchaseform-label">Website Url</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="websiteUrl"
                                                value={formData.websiteUrl}
                                                onChange={(e) => {
                                                    setWebsiteUrl(e.target.value);
                                                    setFormData({ ...formData, websiteUrl: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-row">
                                        <label className="prchaseform-label">Department</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="department"
                                                value={formData.department}
                                                onChange={(e) => {
                                                    setDepartment(e.target.value);
                                                    setFormData({ ...formData, department: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-row">
                                        <label className="prchaseform-label">Designation</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="designation"
                                                value={formData.designation}
                                                onChange={(e) => {
                                                    setDesignation(e.target.value);
                                                    setFormData({ ...formData, designation: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-row">
                                        <label className="prchaseform-label">Twitter</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="tweeterLink"
                                                value={formData.tweeterLink}
                                                onChange={(e) => {
                                                    setTweeterLink(e.target.value);
                                                    setFormData({ ...formData, tweeterLink: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-row">
                                        <label className="prchaseform-label">Skype Name/Number</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="skypeLink"
                                                value={formData.skypeLink}
                                                onChange={(e) => {
                                                    setSkypeLink(e.target.value);
                                                    setFormData({ ...formData, skypeLink: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                    <div className="form-row">
                                        <label className="prchaseform-label">Facebook</label>
                                        <div style={{ width: "600px" }}>
                                            <input
                                                type="facebookLink"
                                                value={formData.facebookLink}
                                                onChange={(e) => {
                                                    setFacebookLink(e.target.value);
                                                    setFormData({ ...formData, facebookLink: e.target.value });
                                                }}
                                            />
                                        </div>
                                    </div>  
                                </>
                                )}
                        </div>
                    )}

                    {activeTab === 'address' && (
                        <div className="form-row">
                            <div className="form-inputs">
                            <h5>Billing Address</h5>
                            {['billingPincode', 'billingCountry', 'billingState', 'billingCity', 'billingAddessLine1', 'billingAddessLine2', 'billingPhoneNumber', 'billingFaxNumber'].map(field => (
                                <div className="form-inputs inline-fields" key={field}  >
                                    <label className="prchaseform-label">{field.replace(/^billing/, '').replace(/([A-Z])/g, ' $1').trim()}</label>
                                    <div style={{ display: "flex", flexDirection: "column", width: "350px", marginBottom: "15px" }}>
                                    {field === 'billingAddessLine1' || field === 'billingAddessLine2' ? (
                                        <textarea
                                            rows={2}
                                            className="form-inputs"
                                            value={formData[field] || ''}
                                            style={{border: "1px solid #ccc", borderRadius:"6px", width: "350px", marginBottom: "15px"}}
                                            onChange={(e) => {
                                                const updated = { ...billingAddress, [field]: e.target.value };
                                                setBillingAddress(updated);
                                                setFormData(prev => ({ ...prev, ...updated }));
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            value={formData[field] || (field === 'billingCountry' ? 'India' : '')}
                                            readOnly={['billingCountry', 'billingState', 'billingCity'].includes(field)}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                let isValid = true;
                                        
                                                if (field === 'billingPincode') {
                                                    isValid = /^[1-9][0-9]{0,5}$/.test(value) || value === '';
                                                } else if (field === 'billingPhoneNumber') {
                                                    isValid = /^[6-9][0-9]{0,9}$/.test(value) || value === '';
                                                }
                                        
                                                if (isValid) {
                                                    const updated = { ...billingAddress, [field]: value };
                                                    setBillingAddress(updated);
                                                    setFormData(prev => ({ ...prev, ...updated }));
                                                    if (field === 'billingPincode' && value.length === 6) { handlePinCodeChange(value, 'billing')}
                                                }
                                            }}
                                        />
                                    )}
                                    {formErrors[field] && (
                                        <small className="error-text">{formErrors[field]}</small>
                                    )}
                                    </div>
                                </div>
                            ))}
                            </div>
                            <div className="form-inputs">                            
                            <h5>
                                Shipping Address 
                                <button type="button" className="btn-link" style={{border: "none", background: "transparent", marginLeft:"10px", fontSize:"16px" }} onClick={copyBillingToShipping}>(Copy Billing Address)</button>
                            </h5>
                            {['shippingPincode', 'shippingCountry', 'shippingState', 'shippingCity', 'shippingAddessLine1', 'shippingAddessLine2', 'shippingPhoneNumber', 'shippingFaxNumber'].map(field => (
                                <div className="form-inputs inline-fields" key={field}>
                                    <label className="prchaseform-label">{field.replace(/^shipping/, '').replace(/([A-Z])/g, ' $1').trim()}</label>
                                    <div style={{ display: "flex", flexDirection: "column", width: "350px", marginBottom: "15px" }}>
                                    {field === 'shippingAddessLine1' || field === 'shippingAddessLine2' ? (
                                        <textarea
                                            rows={2}
                                            className="form-inputs"
                                            value={formData[field] || ''}
                                            style={{border: "1px solid #ccc", borderRadius:"6px", width: "350px", marginBottom: "15px"}}
                                            onChange={(e) => {
                                                const updated = { ...shippingAddress, [field]: e.target.value };
                                                setShippingAddress(updated);
                                                setFormData(prev => ({ ...prev, ...updated }));
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            value={formData[field] || (field === 'shippingCountry' ? 'India' : '')}
                                            readOnly={['shippingCountry', 'shippingState', 'shippingCity'].includes(field)}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                let isValid = true;
                                        
                                                if (field === 'shippingPincode') {
                                                    isValid = /^[1-9][0-9]{0,5}$/.test(value) || value === '';
                                                } else if (field === 'shippingPhoneNumber') {
                                                    isValid = /^[6-9][0-9]{0,9}$/.test(value) || value === '';
                                                }
                                        
                                                if (isValid) {
                                                    const updated = { ...shippingAddress, [field]: value };
                                                    setShippingAddress(updated);
                                                    setFormData(prev => ({ ...prev, ...updated }));
                                                if (field === 'shippingPincode' && value.length === 6) { handlePinCodeChange(value, 'shipping') }
                                                }
                                            }}
                                        />
                                    )}
                                    {formErrors[field] && (
                                            <small className="error-text">{formErrors[field]}</small>
                                    )}
                                    </div>
                                </div>
                            ))}
                            </div>
                        </div>
                    )}

                    {activeTab === 'contact' && (
                        <div>
                            {formData.contactPersons
                            .map((person, index) => ({ person, index }))
                            .filter(({ person }) => person.deleteContactId !== -1)
                            .map(({ person, index }) => (
                                <div className="form-row" key={index} style={{ position: "relative" }}>
                                    {[
                                        { label: "Salutation", key: "salutation" },
                                        { label: "First Name", key: "firstName" },
                                        { label: "Last Name", key: "lastName" },
                                        { label: "Email", key: "email" },
                                        { label: "Phone", key: "phoneNumber" },
                                        { label: "Mobile", key: "mobileNumber" },
                                        { label: "Skype", key: "skypeLink" },
                                        { label: "Designation", key: "designation" },
                                        { label: "Department", key: "department" },
                                    ].map(({ label, key }) => (
                                        <div className="prchaseform-label" key={key} >
                                            {index === 0 && <label>{label}</label>}

                                            {key === "salutation" ? (
                                                <Select
                                                    options={salutationOptions}
                                                    placeholder="Select Salutation"
                                                    value={salutationOptions.find(opt => opt.value === person.salutation)}
                                                    onChange={(selectedOption) =>
                                                        handleContactChange(index, "salutation", selectedOption?.value || "")
                                                    }
                                                    isClearable
                                                />
                                            ) : (
                                                <input
                                                    type="text"
                                                    value={person[key] || ''}
                                                    onChange={(e) => handleContactChange(index, key, e.target.value)}
                                                />
                                            )}
                                            {formErrors[`contactPersons.${index}.${key}`] && (
                                                <span className="error-text">{formErrors[`contactPersons.${index}.${key}`]}</span>
                                            )}
                                        </div>
                                    ))}

                                    {formData.contactPersons.length > 1 && (
                                        <button
                                            onClick={() => removeContactPerson(index)}
                                            className="btn-link"
                                            type="button"
                                            style={{
                                                right: "10px",
                                                top: "10px",
                                                fontSize: "18px",
                                                color: "#d00",
                                                border: "none",
                                                background: "transparent",
                                                cursor: "pointer"
                                            }}
                                            title="Delete this Contact Person"
                                        >
                                            <Trash2 size={18} />
                                        </button>
                                    )}
                                </div>
                            ))}

                            <button
                                type="button"
                                className="btn-link"
                                style={{ border: "none", background: "transparent", marginTop: "10px" }}
                                onClick={addContactPerson}
                            >
                                + Add Contact Person
                            </button>
                        </div>
                    )}

                    {activeTab === 'bank' && (
                        <div>
                            <p>Add your vendor's bank details and make payments.</p>

                            {formData.bankDetails.map((bank, index) => {
                                if (bank.deleteBankId === -1) return null;
                                const isNewBank = !bank.id;

                                return (
                                    <div
                                        key={index}
                                        className="form-row"
                                        style={{
                                            position: 'relative',
                                            marginBottom: '20px',
                                            padding: '15px',
                                            border: '1px solid #ccc',
                                            borderRadius: '8px'
                                        }}
                                    >
                                        <button
                                            onClick={() => removeBankDetail(index)}
                                            className="btn-link"
                                            type="button"
                                            style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "10px",
                                                fontSize: "18px",
                                                color: "#d00",
                                                border: "none",
                                                background: "transparent",
                                                cursor: "pointer"
                                            }}
                                            title="Delete this bank account"
                                        >
                                            <Trash2 size={18} />
                                        </button>

                                        {[
                                            { label: "Account Holder Name", key: "accountHolderName" },
                                            { label: "Bank Name", key: "bankName" },
                                            { label: "IFSC Code", key: "ifscCode" },
                                            { label: "Account Number", key: "accountNumber" },
                                            // { label: "Confirm Account ", key: "confirmAccountNumber" },
                                        ].map(({ label, key }) => (
                                            <div
                                                className="form-group"
                                                key={key}
                                                style={{ marginBottom: '12px' }}
                                            >
                                                <label className="prchaseform-label" htmlFor={`${key}-${index}`}>
                                                    {label}
                                                </label>
                                                <input
                                                    type={key.toLowerCase().includes('number') ? 'number' : 'text'}
                                                    value={bank[key] || ''}
                                                    id={`${key}-${index}`}
                                                    className="form-control"
                                                    onChange={e => handleBankChange(index, key, e.target.value)}
                                                />
                                                {formErrors[`bankDetails.${index}.${key}`] && (
                                                    <span className="error-text">{formErrors[`bankDetails.${index}.${key}`]}</span>
                                                )}
                                            </div>
                                        ))}

                                        {isNewBank && (
                                            <div className="form-group" style={{ marginBottom: '12px' }}>
                                                <label className="prchaseform-label" htmlFor={`confirmAccountNumber-${index}`}>
                                                    Confirm Account Number
                                                </label>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        type={showAccountNumbers[index] ? 'text' : 'password'}
                                                        value={bank.confirmAccountNumber || ''}
                                                        id={`confirmAccountNumber-${index}`}
                                                        className="form-control"
                                                        onChange={(e) =>
                                                            handleBankChange(index, 'confirmAccountNumber', e.target.value)
                                                        }
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => toggleAccountNumberVisibility(index)}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            background: 'transparent',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                        }}
                                                        title={showAccountNumbers[index] ? 'Hide Account Number' : 'Show Account Number'}
                                                    >
                                                        {showAccountNumbers[index] ? <EyeOff size={18} /> : <Eye size={18} />}
                                                    </button>
                                                </div>
                                                {formErrors[`bankDetails.${index}.confirmAccountNumber`] && (
                                                    <span className="error-text">
                                                        {formErrors[`bankDetails.${index}.confirmAccountNumber`]}
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}

                            <button
                                className="btn-link"
                                type="button"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "#1a73e8",
                                    cursor: "pointer",
                                    marginTop: '10px'
                                }}
                                onClick={addBankDetail}
                            >
                                + Add Bank Account
                            </button>
                        </div>
                    )}

                    {activeTab === 'custom' && (
                        <p>
                            Start adding custom fields for your Customers and Vendors by going to Settings &gt; Preferences &gt; Customers and Vendors. You can also refine the address format of your Customers and Vendors from there.
                        </p>
                    )}

                    {activeTab === 'reporting' && (
                        <p>
                            You've not created any Reporting Tags.<br />
                            Start creating reporting tags by going to More Settings &gt; Reporting Tags
                        </p>
                    )}

                    {activeTab === 'remarks' && (
                        <div className="form-group">
                            <label htmlFor="remarks">Remarks (For Internal Use)</label>
                            <textarea
                                id="remarks"
                                value={formData.remarks}
                                onChange={(e) => {
                                    setRemarks(e.target.value);
                                    setFormData({ ...formData, remarks: e.target.value });
                                }}
                                placeholder="Enter any notes or remarks here..."
                                style={{
                                    width: "60%",
                                    minHeight: "120px",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    resize: "vertical",
                                    fontSize: "14px"
                                }}
                            />
                        </div>
                    )}
                    
                </div>

                <div className="form-actions sticky-footer" style={{ Position: "fixed"}}>
                    <button type="submit" className="btn-save">Update</button>
                    <button type="button" className="btn-cancel" onClick={() => history.push(`/vendorDetails/${id}`)}>Cancel</button>
                </div>
            </form>
        </div>
    );
}

export default UpdateVendor;